import {useEffect, useRef} from 'react';

export const useInterval = (callback: () => void, delay: number | null) => {
  const savedCallback = useRef<() => void | null>();
  const intervalId = useRef<number | null>(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }

    if (delay !== null) {
      intervalId.current = setInterval(tick, delay) as unknown as number;
      return () => {
        if (intervalId.current) {
          clearInterval(intervalId.current);
        }
      };
    }
  }, [delay]);

  const cancelInterval = () => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
    }
  };

  return cancelInterval;
};
